import { engineComponent, StringUtils } from "neo-common";
import { ComponentTypes } from "../../Components/ComponentTypes";
import { HtmlButtonElement } from "../Elements/HtmlButtonElement";
import { PlayList } from "../../Components/Sounds/PlayList";
import { AppContext } from "../../../Common/AppContext";
import { HtmlController } from "../HtmlController";

@engineComponent(ComponentTypes.HtmlElement)
export class HtmlHideButtonElement extends HtmlButtonElement {
    static Buttons: { [hideClass: string]: Array<HtmlHideButtonElement> } = {};

    private _hideClass: string = "";

    constructor() {
        super();
    }

    create(node: Element): void {
        super.create(node);

        HtmlController.HideButtons.push(this);

        if (node.hasAttribute("HideClass")) {
            this._hideClass = node.getAttribute("HideClass");
            if (HtmlHideButtonElement.Buttons[this._hideClass] == null) {
                HtmlHideButtonElement.Buttons[this._hideClass] = [];
            }
            HtmlHideButtonElement.Buttons[this._hideClass].push(this);
        }

        if (this.instance != null) {
            if (!AppContext.gameConfiguration.HideAmountsEnabled) {
                this.instance.classList.add("_hidden");
            }
            this.instance.onclick = this.toggle.bind(this);
        }
    }

    public unHide(credit: boolean = false): void {
        if (
            this.instance != null &&
            this._hideClass != "" &&
            (this._hideClass === "_hideBet" || (credit && this._hideClass === "_hideCredit"))
        ) {
            let elements: HTMLCollectionOf<Element> = document.getElementsByClassName(this._hideClass);
            let display: string = "block";

            if (
                HtmlHideButtonElement.Buttons[this._hideClass] != null &&
                HtmlHideButtonElement.Buttons[this._hideClass].length > 0
            ) {
                for (var j: number = 0; j < HtmlHideButtonElement.Buttons[this._hideClass].length; j++) {
                    if (HtmlHideButtonElement.Buttons[this._hideClass][j].instance != null) {
                        if (HtmlHideButtonElement.Buttons[this._hideClass][j].instance.classList.contains("_off")) {
                            HtmlHideButtonElement.Buttons[this._hideClass][j].instance.classList.remove("_off");
                            if (!HtmlHideButtonElement.Buttons[this._hideClass][j].instance.classList.contains("_on")) {
                                HtmlHideButtonElement.Buttons[this._hideClass][j].instance.classList.add("_on");
                            }
                        }
                    }
                }
            }

            for (var i: number = 0; i < elements.length; i++) {
                var element: HTMLElement = <HTMLElement>elements[i];
                if (element != null) {
                    element.style.display = display;
                }
            }

            if (this._hideClass === "_hideCredit") {
                if (display === "block") {
                    AppContext.current.setHideAmounts(false);
                } else {
                    AppContext.current.setHideAmounts(true);
                }
            }
        }
    }

    public hide(credit: boolean = false): void {
        if (
            this.instance != null &&
            this._hideClass != "" &&
            (this._hideClass === "_hideBet" || (credit && this._hideClass === "_hideCredit"))
        ) {
            let elements: HTMLCollectionOf<Element> = document.getElementsByClassName(this._hideClass);
            let display: string = "none";

            if (
                HtmlHideButtonElement.Buttons[this._hideClass] != null &&
                HtmlHideButtonElement.Buttons[this._hideClass].length > 0
            ) {
                for (var j: number = 0; j < HtmlHideButtonElement.Buttons[this._hideClass].length; j++) {
                    if (HtmlHideButtonElement.Buttons[this._hideClass][j].instance != null) {
                        if (HtmlHideButtonElement.Buttons[this._hideClass][j].instance.classList.contains("_on")) {
                            HtmlHideButtonElement.Buttons[this._hideClass][j].instance.classList.remove("_on");
                            if (
                                !HtmlHideButtonElement.Buttons[this._hideClass][j].instance.classList.contains("_off")
                            ) {
                                HtmlHideButtonElement.Buttons[this._hideClass][j].instance.classList.add("_off");
                            }
                        }
                    }
                }
            }

            for (var i: number = 0; i < elements.length; i++) {
                var element: HTMLElement = <HTMLElement>elements[i];
                if (element != null) {
                    element.style.display = display;
                }
            }

            if (this._hideClass === "_hideCredit") {
                if (display === "block") {
                    AppContext.current.setHideAmounts(false);
                } else {
                    AppContext.current.setHideAmounts(true);
                }
            }
        }
    }

    public toggle(): void {
        if (this.instance != null && this._hideClass != "") {
            PlayList.play("SND_Click");
            let elements: HTMLCollectionOf<Element> = document.getElementsByClassName(this._hideClass);
            let display: string = "none";

            if (
                HtmlHideButtonElement.Buttons[this._hideClass] != null &&
                HtmlHideButtonElement.Buttons[this._hideClass].length > 0
            ) {
                for (var j: number = 0; j < HtmlHideButtonElement.Buttons[this._hideClass].length; j++) {
                    if (HtmlHideButtonElement.Buttons[this._hideClass][j].instance != null) {
                        if (HtmlHideButtonElement.Buttons[this._hideClass][j].instance.classList.contains("_on")) {
                            HtmlHideButtonElement.Buttons[this._hideClass][j].instance.classList.remove("_on");
                            if (
                                !HtmlHideButtonElement.Buttons[this._hideClass][j].instance.classList.contains("_off")
                            ) {
                                HtmlHideButtonElement.Buttons[this._hideClass][j].instance.classList.add("_off");
                            }
                        } else {
                            HtmlHideButtonElement.Buttons[this._hideClass][j].instance.classList.remove("_off");
                            if (!HtmlHideButtonElement.Buttons[this._hideClass][j].instance.classList.contains("_on")) {
                                HtmlHideButtonElement.Buttons[this._hideClass][j].instance.classList.add("_on");
                                display = "block";
                            }
                        }
                    }
                }
            }

            for (var i: number = 0; i < elements.length; i++) {
                var element: HTMLElement = <HTMLElement>elements[i];
                if (element != null) {
                    element.style.display = display;
                }
            }

            if (this._hideClass === "_hideCredit") {
                if (display === "block") {
                    AppContext.current.setHideAmounts(false);
                } else {
                    AppContext.current.setHideAmounts(true);
                }
            }
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/HTMLComponents/Custom/HtmlHideButtonElement.ts
 **/